import React, { Component } from 'react';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import Menu, { MenuItem } from 'material-ui/Menu';
import MoreVertIcon from 'material-ui-icons/MoreVert';

class CourseMaterialsItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null
    };
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  handleEdit = () => {
    const {material, editMaterial} = this.props;

    this.handleClose();
    editMaterial(material);
  };

  handleCheck = () => {
    const {material, checkItem} = this.props;

    checkItem(material.id);
  };

  render() {
    const { material, checkedIds } = this.props;
    const { anchorEl } = this.state;
    const isChecked = _.includes(checkedIds, material.id);
    const ITEM_HEIGHT = 48;

    return (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id={`filled-in-box-${material.id}`}
              checked={isChecked}
              onChange={this.handleCheck}
            />
            <label htmlFor={`filled-in-box-${material.id}`} />
          </p>
        </td>
        <td>{material.title || 'N/A'}</td>
        <td>{`${material.user.first_name} ${material.user.last_name}`}</td>
        <td>
          <a
            className='button_classic material-file'
            type='button'
            href={material.file_url}
            target='_blank'>
            View File
          </a>
        </td>
        <td>
          <IconButton
            className="table_more"
            aria-label="More"
            aria-owns={anchorEl ? 'long-menu' : null}
            aria-haspopup="true"
            onClick={this.handleClick}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="long-menu"
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={this.handleClose}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: 200
              }
            }}
          >
            <MenuItem onClick={this.handleEdit}>
              Edit
            </MenuItem>
          </Menu>
        </td>
      </tr>
    );
  }
}

CourseMaterialsItem.defaultProps = {};

CourseMaterialsItem.propTypes = {};

export default CourseMaterialsItem;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/CourseMaterials/CourseMaterialsItem.jsx